import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../../shared/loading';
import * as fromDataServices from '../../data-services';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../../shared/services/logging';
import * as fromRoot from '../../store';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IGenericResponse } from '../../shared';

@Injectable({ providedIn: 'root' })
export class EmployeePayrollItemService extends LoadingService {
    private uri = `${environment.apiLocation}/${fromDataServices.EmployeePayrollItem.entityName}`;
    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }
    public save(
        items: fromDataServices.EmployeePayrollItem.EmployeePayrollItemModel[]
    ): Observable<
        fromDataServices.EmployeePayrollItem.EmployeePayrollItemModel[]
    > {
        return this.http
            .put<
                fromDataServices.EmployeePayrollItem.EmployeePayrollItemModel[]
            >(this.uri, { json: JSON.stringify(items) })
            .pipe(
                tap(resp =>
                    this.log.verbose({
                        type: 'EmployeePayrollItemService:save',
                        resp
                    })
                )
            );
    }
}
